import { Moment } from 'moment'
import { t } from 'helpers/localization'
import {
    SET_SELECTED_TAB,
    GET_TRANSACTIONS,
    FILTER_TRANSACTIONS,
    SHOW_DISTRIBUTION_DIALOG,
    HIDE_DISTRIBUTION_DIALOG,
    SET_FILTER_DATES,
    GET_TOTAL_BALANCE,
    TOGGLE_DISTRIBUTION_MEMBERS,
    SET_DISTRIBUTION_SUM,
    SELECT_DISTRIBUTION_CURRENCY,
    GET_TOTAL_TRANSACTIONS_SUM,
    SET_TRANSACTION_SUM_UPDATING,
    SET_IS_TRANSACTION_LIST_UPDATING,
    DISTRIBUTE_RESOURCES,
    SHOW_DISTRIBUTION_RESULT_DIALOG,
    HIDE_DISTRIBUTION_RESULT_DIALOG,
    LISTEN_TRANSACTIONS_STATUS_UPDATES,
    APPEND_TRANSACTIONS,
    SET_DISTRIBUTION_FILTER,
    TOGGLE_IS_DISTRIBUTION_FILTER_VISIBLE,
    SET_SORT_FIELD,
    GET_TREASURY_CONFIG,
    UPDATE_TREASURY_BOXES_COOLDOWN,
    OPEN_REGULAR_REWARD_CONFIRM_DIALOG,
    CLOSE_REGULAR_REWARD_CONFIRM_DIALOG,
} from '../Actions/ActionTreasury'

import {
    TRANSACTIONS_STATUSES_MAP,
} from '../Actions/ActionTreasury'

type Action = any
type CurrencyType = any

export interface RegularReward {
    title: string,
    interval: number,
    description: string,
    price: number,
    requiredLevel: number
}

import Currency from '@wg/wows-react-uikit/Currency'


const regularRewards = {
    offer_1: {
        title: t('Больше ресурсов для всех'),
        description: t('1 контейнер «Больше ресурсов» с вероятностью выпадения суперконтейнера каждому участнику клана.'),
    },
    offer_2: {
        title: t('Испытать удачу для всех'),
        description: t('5 контейнеров «Испытать удачу» с вероятностью выпадения суперконтейнера каждому участнику клана.'),
    },
    offer_3: {
        title: t('Суперконтейнеры для всех'),
        description: t('1 суперконтейнер каждому участнику клана.'),
    },
    offer_4: {
        title: t('Дополнительные ресурсы для всех'),
        description: t('1 контейнер «Больше ресурсов» с вероятностью выпадения суперконтейнера каждому участнику клана.'),
    },
    offer_5: {
        title: t('Дополнительно испытать удачу для всех'),
        description: t('5 контейнеров «Испытать удачу» с вероятностью выпадения суперконтейнера каждому участнику клана.'),
    },
    offer_6: {
        title: t('Дополнительные суперконтейнеры для всех'),
        description: t('1 суперконтейнер каждому участнику клана.'),
    },
}

export type State = {
    transactionsRaw: Transactions,
    transactions: Transactions,
    selectedTab: number,
    isDistributionVisible: boolean,
    filterStartDate: Moment | null,
    filterEndDate: Moment | null,
    totalBalanceList: Balance,
    totalTransactionsSum: Balance,
    isTotalTransactionsSumUpdating: boolean,
    isTransactionListUpdating: boolean,
    distributionList: Array<number>,
    distributionSum: number,
    selectedDistributionCurrency: CurrencyType,
    detailViewTransaction: Transaction | null,
    isDistributionResultDialogVisible: boolean,
    isAppending: boolean,
    transactionsOffset: number,
    lastOffet: number | null,
    distributionPlayerFilter: string,
    isDistributionFilterInputVisible: boolean,
    sortDirection: null | 'ask' | 'desc',
    sortField: string | null,
    regularRewards: Array<RegularReward>,
    isTreasuryConfigReady: boolean,
    isRegularRewardConfirmDialogVisible: boolean,
    rewardToConfirm: any
}


let initialState: State = {
    transactionsRaw: [],
    transactions: [],
    selectedTab: 0,
    isDistributionVisible: false,
    filterStartDate: null,
    filterEndDate: null,
    totalBalanceList: [],
    totalTransactionsSum: [],
    isTotalTransactionsSumUpdating: false,
    isTransactionListUpdating: false,
    distributionList: [],
    distributionSum: 0,
    selectedDistributionCurrency: 'steel',
    isDistributionResultDialogVisible: false,
    detailViewTransaction: null,
    isAppending: false,
    transactionsOffset: 0,
    lastOffet: null,
    distributionPlayerFilter: '',
    isDistributionFilterInputVisible: false,
    sortDirection: 'ask',
    sortField: 'roleName', //null,
    regularRewards: {
        availableRewardOffers: [],
        isEnabled: false,
        minDaysInClan: 0,
        minDistributionSum: 0
    },
    isTreasuryConfigReady: false,
    cooldownUpdated: false,
    isRegularRewardConfirmDialogVisible: false,
    rewardToConfirm: null
}

const getTransactionCount = (transactions) => {
    let count = 0

    if (transactions && transactions.length) {
        transactions.forEach((dayTransactions) => {
            if (dayTransactions && dayTransactions.transactions) {
                count += dayTransactions.transactions.length
            }
        })
    }

    return count
}

const haveThisDay = (array, date) => {
    let isInside = null

    if (array && array.length) {
        array.forEach((item) => {
            if (!isInside && item.date === date) {
                isInside = item
            }
        })
    }

    return isInside
}

export type IReducerTreasury = (state: State, action: Action) => State
export const ReducerTreasury = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case OPEN_REGULAR_REWARD_CONFIRM_DIALOG: {
            return {
                ...state,
                isRegularRewardConfirmDialogVisible: true,
                rewardToConfirm: action.payload.reward
            }
        }
        case CLOSE_REGULAR_REWARD_CONFIRM_DIALOG: {
            return {
                ...state,
                isRegularRewardConfirmDialogVisible: false,
                rewardToConfirm: null
            }
        }
        case UPDATE_TREASURY_BOXES_COOLDOWN: {
            return {
                ...state,
                cooldownUpdated: true,
                regularRewards: {
                    ...action.payload.config,
                    availableRewardOffers: state.regularRewards.availableRewardOffers.map(reward => {

                        let updatedReward = {
                            ...reward
                        }

                        if (action.payload.data[reward.offer_id]) {
                            updatedReward = {
                                ...updatedReward,
                                ...action.payload.data[reward.offer_id]
                            }
                        } else {
                            updatedReward = {
                                ...updatedReward,
                                classifier: 0,
                                delay: 0,
                                lastReceive: null
                            }
                        }

                        return updatedReward
                    })
                }
            }
        }
        case GET_TREASURY_CONFIG: {
            return {
                ...state,
                isTreasuryConfigReady: true,
                regularRewards: {
                    ...action.payload.config,
                    availableRewardOffers: action.payload.config.availableRewardOffers.map((reward, index) => {
                        return {
                            ...state.regularRewards.availableRewardOffers[index],
                            ...reward,
                            ...regularRewards[reward.offer_id]
                        }
                    })
                }
            }
        }
        case SET_SORT_FIELD: {
            let newSortDirection = (state.sortDirection === 'ask') ? 'desc' : 'ask'
            return {
                ...state,
                sortField: (action.payload.sortField === '') ? null : action.payload.sortField,
                sortDirection: newSortDirection,
            }
        }
        case TOGGLE_IS_DISTRIBUTION_FILTER_VISIBLE: {
            return {
                ...state,
                isDistributionFilterInputVisible: !state.isDistributionFilterInputVisible,
            }
        }
        case SET_DISTRIBUTION_FILTER: {
            return {
                ...state,
                distributionPlayerFilter: action.payload.value,
            }
        }
        case APPEND_TRANSACTIONS: {
            return {
                ...state,
                isAppending: action.payload.isAppending,
            }
        }
        case LISTEN_TRANSACTIONS_STATUS_UPDATES: {

            let transactionUpdates = {}
            action.payload.data.forEach((item) => {
                transactionUpdates[item.id] = item
            })
            let newTransactions = state.transactions.map((dayTransactions) => {
                return {
                    ...dayTransactions,
                    transactions: dayTransactions.transactions.map((singleTransaction) => {

                        const gtId = singleTransaction.data.gameTransactionId ? singleTransaction.data.gameTransactionId : 0
                        if (transactionUpdates[gtId]) {
                            const newsSingleTransaction = {
                                ...singleTransaction,
                                status: TRANSACTIONS_STATUSES_MAP[transactionUpdates[gtId].status],
                                data: {
                                    ...singleTransaction.data,
                                    failedReceivers: transactionUpdates[gtId].failedReceivers,
                                },
                            }
                            return newsSingleTransaction
                        } else if (singleTransaction.childTransactions && singleTransaction.childTransactions.length) {
                            return {
                                ...singleTransaction,
                                childTransactions: singleTransaction.childTransactions.map((childTransaction) => {
                                    const childGtId = childTransaction.data.gameTransactionId ? childTransaction.data.gameTransactionId : 0
                                    if (transactionUpdates[childGtId]) {
                                        const newsSingleChildTransaction = {
                                            ...childTransaction,
                                            status: TRANSACTIONS_STATUSES_MAP[transactionUpdates[childGtId].status],
                                            data: {
                                                ...childTransaction.data,
                                                failedReceivers: transactionUpdates[childGtId].failedReceivers,
                                            },
                                        }
                                        return newsSingleChildTransaction
                                    } else {
                                        return childTransaction
                                    }
                                }),
                            }
                        } else {
                            return singleTransaction
                        }
                    }),
                }
            })

            return {
                ...state,
                transactions: newTransactions,
            }
        }
        case SHOW_DISTRIBUTION_RESULT_DIALOG: {
            return {
                ...state,
                detailViewTransaction: action.payload.transaction,
                isDistributionResultDialogVisible: true,
            }
        }
        case HIDE_DISTRIBUTION_RESULT_DIALOG: {
            return {
                ...state,
                detailViewTransaction: null,
                isDistributionResultDialogVisible: false,
            }
        }
        case DISTRIBUTE_RESOURCES: {
            return {
                ...state,
                distributionList: [],
                distributionSum: 0,
            }
        }
        case SET_IS_TRANSACTION_LIST_UPDATING: {
            return {
                ...state,
                isTransactionListUpdating: action.payload.isUpdating,
                isAppending: false,
            }
        }
        case SET_TRANSACTION_SUM_UPDATING: {
            return {
                ...state,
                isTotalTransactionsSumUpdating: true,
            }
        }
        case GET_TOTAL_TRANSACTIONS_SUM: {
            return {
                ...state,
                totalTransactionsSum: action.payload.totalTransactionsSum,
                isTotalTransactionsSumUpdating: false,
            }
        }
        case SELECT_DISTRIBUTION_CURRENCY: {
            return {
                ...state,
                selectedDistributionCurrency: action.payload.type,
            }
        }
        case SET_DISTRIBUTION_SUM: {
            return {
                ...state,
                distributionSum: action.payload.sum,
            }
        }
        case TOGGLE_DISTRIBUTION_MEMBERS: {
            let newDistributionList = state.distributionList.slice()

            if (action.payload.toggleAll) {
                if (action.payload.members.length === 0 || action.payload.members.length === newDistributionList.length) {
                    newDistributionList = []
                } else {
                    newDistributionList = action.payload.members
                }
            } else {
                action.payload.members.forEach((id) => {
                    if (newDistributionList.indexOf(id) !== -1) {
                        newDistributionList = newDistributionList.filter((item) => item !== id)
                    } else {
                        newDistributionList.push(id)
                    }
                })
            }

            return {
                ...state,
                distributionList: newDistributionList,
            }
        }
        case GET_TOTAL_BALANCE: {

            let defaultCurrency = action.payload.totalBalanceList.filter((currency) => {
                return currency.canDistribute === true && currency.amount > 0
            })[0]

            return {
                ...state,
                totalBalanceList: action.payload.totalBalanceList,
                selectedDistributionCurrency: defaultCurrency ? defaultCurrency.type : Currency.types['steel'],
            }
        }
        case SET_FILTER_DATES: {
            return {
                ...state,
                filterStartDate: action.payload.start,
                filterEndDate: action.payload.end,
            }
        }
        case SHOW_DISTRIBUTION_DIALOG: {
            return {
                ...state,
                isDistributionVisible: true,
            }
        }
        case HIDE_DISTRIBUTION_DIALOG: {
            return {
                ...state,
                isDistributionVisible: false,
                distributionSum: 0,
            }
        }
        case SET_SELECTED_TAB: {
            return {
                ...state,
                selectedTab: parseInt(action.payload.index),
                isAppending: false,
                transactionsOffset: 0,
                lastOffet: null,
            }
        }
        case FILTER_TRANSACTIONS: {
            return {
                ...state,
                transactions: action.payload.transactions,
            }
        }
        case GET_TRANSACTIONS: {
            if (state.isAppending) {
                const mergedTransactions = []
                const newTransactions = action.payload.transactions

                state.transactions.forEach((dayTransaction) => {
                    const dayToMerge = haveThisDay(newTransactions, dayTransaction.date)
                    if (dayToMerge !== null) {
                        mergedTransactions.push({
                            ...dayTransaction,
                            transactions: dayTransaction.transactions.concat(dayToMerge.transactions),
                        })
                    } else {
                        mergedTransactions.push(dayTransaction)
                    }
                })

                newTransactions.forEach((dayTransaction) => {
                    const dayToMerge = haveThisDay(state.transactions, dayTransaction.date)
                    if (dayToMerge === null) {
                        mergedTransactions.push(dayTransaction)
                    }
                })

                return {
                    ...state,
                    transactions: mergedTransactions,
                    isAppending: false,
                    transactionsOffset: getTransactionCount(mergedTransactions),
                    lastOffet: action.payload.lastOffet,
                }
            } else {
                return {
                    ...state,
                    transactions: action.payload.transactions,
                    isAppending: false,
                    transactionsOffset: getTransactionCount(action.payload.transactions),
                    lastOffet: action.payload.lastOffet,
                }
            }


        }
        default:
            return state
    }
}
